import React, { useEffect, useState ,useMemo } from "react";
import { useParams } from "react-router-dom";
import MakeTransaction from "./MakeTransaction";

import { getTransactionList, getAllProjectTransaction, deleteTransaction } from "../../services/transaction.service";
import { getProject } from "../../services/Project.service";
import AddIcon from "../../assets/images/add_icon.svg";
import toast from "react-hot-toast";
import PaginatedTable from "../common/PaginatedTable";
import EditIcon from "../../assets/images/edit_icon.svg";
import ViewIcon from "../../assets/images/view_icon.svg";
import DeleteIcon from "../../assets/images/delete_icon.svg";
import { useNavigate } from "react-router-dom";
import MakeInternalTransaction from "./MakeInternalTransaction";
import TransactionPopup from "./TransactionPopup"
import ConfirmPopup from "../common/confirmation component/ConfirmPopup";
 import { AgGridReact } from "ag-grid-react";
 import  './AllTransactionReport.module.css';


const AllTransactionReport = () => {

  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showinternalTransferDialog, setshowinternalTransferDialog] = useState(false);
  const [showTable, setShowTable] = useState(true);

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  let [deleteRequest, setDeleteRequested] = useState(false);

  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [ProjectList, setProjectList] = useState([]);
  let { id } = useParams();

  //setStatusFilter(id)

  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [activePopup, setActivePopup] = useState(null);

  const confirm = {
    status: "status",
    delete:  "delete",
  };

  const handleShowCreate = () => {
    setShowCreate(true);
    setshowinternalTransferDialog(false)
    setShowTable(false);
  };
  const handleshowinternalTransferDialog = () => {
    setShowCreate(false);
    setShowTable(false);
    setshowinternalTransferDialog(true)
  };

  const back = (cond = true) => {
    cond && transactionList();
    setShowCreate(false);
    setshowinternalTransferDialog(false)
    setShowTable(true);
  };
  const handleDelete = async (id) => {
    try {
      const res = await deleteTransaction({ "id": id });
      setDeleteRequested(!deleteRequest);
      if (res?.status === 200) {

        if (res?.data) {
          setProjectList(res.data);
        }
      } else {
        toast.error(res?.message || res?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        // alert(msg);
        console.error(msg);
      }
      console.log(error.message);
    }
  }

  useEffect(() => {
    transactionList();
    getProjectList();
  }, [currentPage, itemsPerPage, searchKey, setSearchKey, statusFilter, deleteRequest]);
  const getProjectList = async () => {
    try {
      const res = await getProject();


      if (res?.status === 200) {

        if (res?.data) {
          setProjectList(res.data);
        }
      } else {
        toast.error(res?.message || res?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        // alert(msg);
        console.error(msg);
      }
      console.log(error.message);
    }
  };
  const handleRowClick = (row) => {
    setSelectedTransaction(row);
    setShowPopup(true)
  }
  const [column, setColumn] = useState([
    // {
    //   heading: () => "S.No",
    //   cell: (row, i) => {
    //     return i;
    //   },
    //   hidden: false,
    //   width: "20",
    //   id: 1,
    // },
    {
      heading: () => "Action",
      cell: (row) => (
        <>
          <div>
            <img className="CyanSky_filter" onClick={() => handleRowClick(row)} src={ViewIcon} alt="View" />
            {/* <img className="CyanSky_filter" onClick={() => navigate(`/admin/edit-transaction/${row?.id}`)} src={EditIcon} alt="Edit" />
          <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" /> */}
          </div>
        </>
      ),

      hidden: false,
      // width: "120",
      // align: "center",
      id: 1,
    },
    {
      heading: () => "Name",
      cell: (row) => (row["name"] ? row["name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },
    {
      heading: () => "Amount",
      cell: (row) => (row["amount"] ? row["amount"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },

    {
      heading: () => "From",
      cell: (row) => (row["from"] ? row["from"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 4,
    },
    {
      heading: () => "To",
      cell: (row) => (row["to"] ? row["to"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 5,
    },
    // {
    //   heading: () => "Description",
    //   cell: (row) => (row["descripton"] ? row["descripton"] : "-"),
    //   hidden: false,
    //   width: "120",
    //   align: "left",
    //   id: 4,
    // },
    {
      heading: () => "Tansaction date",
      cell: (row) => (row["transactionDate"] ? row["transactionDate"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 6,
    },

    {
      heading: () => "Flow",
      cell: (row) => (row["flow"] ? row["flow"] == 1 ? "Outgoing" : row["flow"] == 0 ? "Incoming" : "Incoming" : "Incoming"),
      hidden: false,
      width: "120",
      align: "left",
      id: 7
    },

    {
      heading: () => "Transaction Status",
      cell: (row) => (row["transactionStatus"] ? "Active" : "Inactive"),
      hidden: false,
      width: "120",
      align: "left",
      id: 8
    },
     {
      heading: () => "CreatedBy",
      cell: (row) => (row["createdBy"] ? row["createdBy"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 8,
    },

    {
      heading: () => "Action",
      cell: (row) => (
        <>
          <div>
            {/* <img className="CyanSky_filter" onClick={() => navigate(`/admin/edit-transaction/${row?.id}`)} src={ViewIcon} alt="View" /> */}
            <button   onClick={() => navigate(`/admin/edit-transaction/${row?.id}`)}  >
            <img className="CyanSky_filter" src={EditIcon} alt="Edit" />
            </button>
            <button  onClick={() => setActivePopup({ action: "delete", data: {row} })} >
            <img className="CyanSky_filter" src={DeleteIcon} alt="Delete" onClick={() => setActivePopup({ action: "delete", data: {row} })} />
            </button>
          </div>
        </>
      ),

      hidden: false,
      // width: "120",
      // align: "center",
      id: 1,
    },
  ]);

  
  function updateGridColumns(data) {
  const columnDefs = Object.keys(data[0]).map(key => ({
    headerName: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize header
    field: key
  }));
setColDefs(colDefs);
  // gridOptions.api.setColumnDefs(columnDefs);
  // gridOptions.api.setRowData(data);
}
  const transactionList = async () => {
    const offset = (currentPage - 1) * itemsPerPage;
    const offsetToUse = offset >= 0 ? offset : 0;

    try {
      const requestBody = {
        offset: offsetToUse,
        limit: itemsPerPage,
        search: searchKey,
      };
      let res = {};
      // if (statusFilter != '') {
        res = await getAllProjectTransaction(requestBody);
      // }
      // }else{
      //   res = await getTransactionList(requestBody);
      // }

      if (res?.status === 200) {
        setList(res.data);
        setTotalCount(res.data.length);
        updateGridColumns(res.data);
      } else {
        toast.error(res?.message || res?.data?.message);
      }

    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        console.error(msg);
        // alert(msg);
      }
      console.log(error.message);
    }
  };
  const confirmPopFunction = () => {
    if (activePopup&& activePopup.action && confirm?.delete === activePopup.action) 
    {
      debugger;
      handleDelete(activePopup.data?.row.id);
    }
    setActivePopup(null);
  };
  function capitalizeWords(sentence) {
    if(sentence)
    {
  return sentence.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }
    return sentence;
}


  const gridOptions = {
  columnDefs: [],
  rowData: [],
  defaultColDef: { sortable: true, filter: true },
  groupTotalRow: 'bottom',
  autoGroupColumnDef: {
    cellRendererParams: {
      totalValueGetter: params => params.node.level === -1 ? 'Grand Total' : `Subtotal (${params.value})`,
    },
  },

};
const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
    };
  }, []);

const sideBar = false;
const rowGroupEnable=false;
const groupDisplayType = 'multipleColumns';

  const visibleTable = !showinternalTransferDialog && !showCreate
    const [colDefs, setColDefs] = useState([
      { headerName: "Project Name",field:"projectName",rowGroup: rowGroupEnable  ,enableRowGroup:true},
      { headerName: "Transaction Date" ,field:"transactionDate" ,valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString() : '' },
      { headerName: "Location" ,field:"location",rowGroup: rowGroupEnable ,enableRowGroup:true},
    { headerName: "From" ,field:"from",rowGroup: true ,valueFormatter:params=>capitalizeWords(params.value),enableRowGroup:true, hide: true},
    { headerName: "To" ,field:"to" ,rowGroup: rowGroupEnable,valueFormatter:params=>capitalizeWords(params.value),enableRowGroup:true},
    { headerName: "Credit" ,field:"debit",valueFormatter: params => { return  params.value==0?'': '₹' + params.value },aggFunc: 'sum',
    cellStyle: { fontWeight: 'bold', color: 'green'  },cellClassRules: {
    'bold-green': params => params.node.group // Apply only to group rows
  }
},
    { headerName: "Debit" ,field:"credit" ,valueFormatter: params => { return  params.value==0?'': '₹' + params.value},aggFunc: 'sum',
    cellStyle: { fontWeight: 'bold', color: 'red' }
},
    { headerName: "Payment Mode" ,field:"tansactionMode" ,hide:true},
   
    // { headerName: "Flow" ,field:"flow",valueGetter: params => params.data.flow? params.data.flow === 1 ? "Outgoing" : "Incoming":"-" },
    // { headerName: "Transaction Status" ,field:"transactionStatus" ,valueGetter: params => params.data.flow === 1 ? "Active" : "InActive"},
    { headerName: "CreatedBy" ,field:"createdBy",valueFormatter:params=>capitalizeWords(params.value),enableRowGroup:true },
    { headerName: "Descripton" ,field:"descripton",hide:true },
    { headerName: "Created Date" ,field:"createdDate" },
    
    // { headerName: "projectID" ,field:"projectID" ,hide:true},
    // { headerName: "Location ID" ,field:"locationID" ,hide:true},
    // { headerName: "Destination ID" ,field:"destinationID" ,hide:true},
    // { headerName: "ParentId" ,field:"parentId" ,hide:true},
    // { headerName: "userID" ,field:"userID" },
    // { headerName: "User" ,field:"user",rowGroup: rowGroupEnable },
  ]);
  
  // Apply settings across all columns
const defaultColDef = useMemo(() => ({
    filter: true // Enable filtering on all columns
}))


  return (
    <div>
        {visibleTable && (
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                Transaction List
              </h5>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleshowinternalTransferDialog}
              >
                <img className="width20px" src={AddIcon} alt="AddIcon" />
                <span> Internal Transfer </span>
              </button>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleShowCreate}
              >
                <img className="width20px" src={AddIcon} alt="AddIcon" />
                <span> Create Transaction </span>
              </button>
            </div>

          </div>
        )}
  <div style={{ height: 700 }}>
        <AgGridReact rowData={list} columnDefs={colDefs} sideBar={sideBar}
        defaultColDef={defaultColDef} 
          autoGroupColumnDef={autoGroupColumnDef} 
            rowGroupPanelShow={"always"}
              groupDefaultExpanded={0}
              groupDisplayType={groupDisplayType}
               grandTotalRow={"bottom"}
                groupTotalRow={"bottom"}
        />
    </div>
      <ConfirmPopup
        message="Are you sure you want to delete this item?"
        onConfirm={confirmPopFunction}
        onCancel={() => setActivePopup(null)}
        isOpen={activePopup && activePopup.action &&confirm?.delete === activePopup.action}
      />
      {showPopup && <TransactionPopup item={selectedTransaction} onClose={() => setShowPopup(false)} />}
      {showCreate && <MakeTransaction back={back} statusFilter={statusFilter} />}
      {showinternalTransferDialog && <MakeInternalTransaction back={back} statusFilter={statusFilter} />}
    </div>
  );
};

export default AllTransactionReport;
